ft.app.directive('ftIsolatedScope', function () {
    return {
        scope: {},
        link: function () {
        }
    };
});
